import { required, maxLength, minLength, numeric, integer, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a product name.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product name cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        minLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product name must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
          minLength(3)
        ),
        pattern: helpers.withMessage(i18n.global.t('Product names can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Za-zก-๙0-9_/&+.,'"()% -]+$/)),
      },
      // ชื่ออังกฤษ optional — ไม่กรอกก็ได้ ระบบจะ fallback ไปใช้ชื่อไทย
      name_en: {
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product name cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        pattern: helpers.withMessage(i18n.global.t('English product names can include English letters, numbers, and certain special characters.'), helpers.regex(/^[A-Za-z0-9-_/&+.,'"()% ]+$/)),
      },
      product_category_id: {
        required: helpers.withMessage(i18n.global.t('Please enter a category.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      code: {
        // required: helpers.withMessage(i18n.global.t('Please enter a product code.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product code cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        minLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product code must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
          minLength(3)
        ),
        pattern: helpers.withMessage(i18n.global.t('Product names can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_/& ]+$/)),
      },
      barcode: {
        required: helpers.withMessage(i18n.global.t('Please enter a product barcode.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product barcode cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        minLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product barcode must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
          minLength(3)
        ),
        pattern: helpers.withMessage(i18n.global.t('Product barcodes can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_/& ]+$/)),
      },
      description: {
        pattern: helpers.withMessage(i18n.global.t('Description contains invalid characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_.,!@#$%^&*()+=:;<>?/\|\[\]{}"'\s<>]+$/))
      },
      // คำอธิบายอังกฤษ optional — ไม่กรอกก็ได้ ระบบจะ fallback ไปใช้คำอธิบายไทย
      description_en: {
        pattern: helpers.withMessage(i18n.global.t('Description contains invalid characters.'), helpers.regex(/^[A-Za-z0-9-_.,!@#$%^&*()+=:;<>?/\|\[\]{}"'\s<>]+$/))
      },
      price: {
        required: helpers.withMessage(i18n.global.t('Please enter a product price.'), requiredIf(formState.is_config == 0)),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the product price.'), numeric)
      },
      compare_at_price: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the compare at price.'), numeric),
        greaterThanPrice: helpers.withMessage(
          i18n.global.t('Compare at price must be higher than the price.'),
          (value) => !value || Number(value) > Number(formState.price)
        )
      },
      cost_estimate: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the product cost.'), numeric)
      },
      tax_status: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
      },
      image: {
      },
      is_active: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
      },
      is_recommend: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
      },
      dine_in_only: {
      },
      pos_only: {
      },
      is_config: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
      },
      serving_size_value: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the serving size.'), numeric),
      },
      serving_size_unit_id: {
        required: helpers.withMessage(i18n.global.t('Please enter a product serving size unit.'), requiredIf(formState.serving_size_value > 0)),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      unit_id: {
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      attributes: {
        required: helpers.withMessage(i18n.global.t('Please select an attribute.'), requiredIf(formState.is_config == 1)),
        maxLength: helpers.withMessage(i18n.global.t('You can select up to 2 attributes.'), maxLength(2))
      },
      variants: {
        required: helpers.withMessage(i18n.global.t('Please add at least one variant.'), requiredIf(formState.is_config == 1)),
      },
      cost_manual: {}
    }
  }
};
